import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRequirements = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 1C9.55228 1 10 1.44772 10 2H13C13.5523 2 14 2.44772 14 3V14C14 14.5177 13.6067 14.9438 13.1025 14.9951L13 15H3L2.89746 14.9951C2.42703 14.9472 2.05278 14.573 2.00488 14.1025L2 14V3C2 2.44772 2.44772 2 3 2H6C6 1.44772 6.44772 1 7 1H9ZM3 14H13V3H10C10 3.55228 9.55228 4 9 4H7C6.44772 4 6 3.55228 6 3H3V14ZM10.5 10.5C10.7761 10.5 11 10.7239 11 11C11 11.2761 10.7761 11.5 10.5 11.5H5.5C5.22386 11.5 5 11.2761 5 11C5 10.7239 5.22386 10.5 5.5 10.5H10.5ZM10.5 6.5C10.7761 6.5 11 6.72386 11 7C11 7.27614 10.7761 7.5 10.5 7.5H5.5C5.22386 7.5 5 7.27614 5 7C5 6.72386 5.22386 6.5 5.5 6.5H10.5Z",
		fill: "currentColor"
	})
});
export default SvgRequirements;
